import {
  getBuzzFeedServiceWorkerRegistration,
  registerServiceWorker,
} from './service-worker-manager';
import { loadScript } from '@buzzfeed/bf-utils/lib/load-script';

/**
 * Initialize Taboola push notifications
 * Runs on ALL pages
 */

const TABOOLA_PUSH_SW_PATH = '/service-worker.js';
const TABOOLA_PUSH_SDK_URL =
  'https://cdn.taboola.com/webpush/publishers/1966858/taboola-push-sdk.js';

function ensureTaboolaPushGlobals() {
  if (typeof window === 'undefined') {
    return;
  }

  window._taboola_notifications = window._taboola_notifications || [];

  const hasSwPath = window._taboola_notifications.some(
    (entry) => entry && entry.swPath === TABOOLA_PUSH_SW_PATH
  );

  if (!hasSwPath) {
    window._taboola_notifications.push({ swPath: TABOOLA_PUSH_SW_PATH });
  }
}

function ensureTaboolaPushSdkLoaded() {
  if (typeof document === 'undefined') {
    return;
  }

  const existingScript = document.querySelector(
    `script[src="${TABOOLA_PUSH_SDK_URL}"]`
  );

  if (!existingScript) {
    loadScript(TABOOLA_PUSH_SDK_URL);
  }
}

export async function initTaboolaPush(buzz, getFeatureFlagValue) {
  if (!getFeatureFlagValue) {
    throw new Error('Missing getFeatureFlagValue function');
  }

  if (!buzz) {
    return null;
  }

  const { isPreview } = buzz;
  const isTaboolaPushNotificationsEnabled = getFeatureFlagValue(
    'bf_taboola_push_notifications_enabled'
  );
  const isEnabled = !isPreview && isTaboolaPushNotificationsEnabled;

  try {
    if (!isTaboolaPushNotificationsEnabled) {
      // Unsubscribe is the kill switch. No subscription = no push events delivered,
      // even when the SW restarts with no page open to send a disable message
      console.log('[Taboola Push] Disabled by feature flag');
      const registration = await getBuzzFeedServiceWorkerRegistration();
      const subscription = await registration?.pushManager?.getSubscription?.();
      if (subscription) await subscription.unsubscribe();
      return null;
    }

    // Additional targeting is controlled by the feature flag audience.
    if (!isEnabled) {
      return null;
    }

    ensureTaboolaPushGlobals();
    ensureTaboolaPushSdkLoaded();

    // Register service worker (safe to call even if already registered)
    const registration = await registerServiceWorker();

    return registration;
  } catch (err) {
    console.error('[Taboola Push] Initialization error:', err);
    return null;
  }
}
